<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useStore } from '@/stores/store'
import { IconArrowRight } from '@/components/icons';
import { MailIcon, PhoneIcon } from 'lucide-vue-next';
import { onMounted, ref } from 'vue';

const { currentStep } = storeToRefs(useStore())
const contactUsHref = ref('/')
onMounted(() => {
  currentStep.value = 0
  if(import.meta.env.PROD && window?.BASE_URL) {
    contactUsHref.value = window.BASE_URL + 'contact'
  }
})
</script>

<template>
  <div id="start" class="start-page-wrapper mt-10" v-if="currentStep === 0">
    <div class="border border-black/40 p-6">
      <h4 class="text-lg lg:text-2xl font-semibold ">{{ $t('Cushions according to your needs') }}</h4>
      <p class="mt-2 base-text">{{ $t('Do you want to ensure you get a cushion with delicious, quality materials according to your unique measurements?') }}</p>
      <p class="mt-10 mb-9 base-text">{{ $t('We tailor leather and fabric cushions to your needs and wishes. Design your own cushion here.') }}</p>
      <button class="btn btn-primary lg:w-auto" type="button" @click="currentStep = 1">
        <span>{{ $t('Start designing') }}</span>
        <IconArrowRight></IconArrowRight>
      </button>
    </div>
    <div class="mt-10">
      <h3 class="font-semibold text-2xl lg:text-3xl font-montserrat">{{ $t('Material samples') }}</h3>
      <p class="base-text mt-1 mb-5">{{ $t('You can always order free material samples from us if you want to see the fabric or leather first.') }}</p>
      <button type="button" class="btn btn-primary text-primary bg-transparent lg:w-auto border text-base py-3 border-primary">{{ $t('Order material samples') }}</button>
    </div>
    <div class="my-10">
      <h3 class="font-semibold font-montserrat text-2xl lg:text-3xl">{{ $t('Contact') }}</h3>
      <p class="base-text mt-2">{{ $t('Do you need a cushion for your home or office – or do you want a solution tailored to your goals? We work with all types of fabric and leather and emphasize good craftsmanship and durability.') }}</p>
      <p class="base-text mt-5 mb-5">{{ $t(`We are specialists in upholstery and can meet your expectations for the perfect cushion. So don't hesitate to contact us if you need anything.`) }}</p>
      <div class="flex flex-col gap-4 mb-6">
      <a class="flex gap-2 justify-start items-center" href="mailto:info@wedocushions.com" ><MailIcon class="w-5"></MailIcon><span>info@recollection.dk</span></a>
      <a class="flex gap-2 justify-start items-center" href="tel:+4552282000" ><PhoneIcon class="w-5"></PhoneIcon><span>(+45)52 28 20 00</span></a>
      </div>
      <a :href="contactUsHref" target="_blank" rel="noopener noreferrer" class="btn btn-primary text-primary bg-transparent lg:w-auto border text-base py-3 border-primary">{{ $t('Contact us') }}</a>
    </div>
  </div>
</template>
